export default __webpack_public_path__ + "static/media/tortcc.ba6619ea.png";